import React, {useEffect, useState, useContext} from 'react';
import {BoardDetailContents, BoardDetailComments, HeaderBackground, Footer} from 'components/section';
import {Redirect} from 'react-router-dom';
// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/storage';
import { authContext } from '../shared/App';
const db = firebase.firestore();


const BoardDetail = ({match, location, gnb, lnb}) => {
  const [data, setData] = useState();
  const [col] = useState(`${gnb}_${lnb}`);
  const [doc] = useState(match.params.name);
  const [answer, setAnswer] = useState(false);
  const {setIsDetail} = useContext(authContext);

  useEffect(()=> {
    if(lnb === 'qna'){
      const temp = prompt('비밀번호를 입력하세요.');
      setAnswer(temp)
    }
  }, [lnb])

  useEffect(()=> {
    if(location.query){
      setData(location.query.data);
    }else{
      const _get = async () => {
        const getData = await db.collection(col).doc(doc).get();    
        setData(getData.data());
      }
      _get();
    }
    setIsDetail(true);
  }, [col, doc, location, setIsDetail])

  const drawDetail = () => {
    // 정보 바꾸기
    if(lnb === 'qna'){
      if(answer===data.password){
        return  <div className="inner-boardDetail">
                  <HeaderBackground />
                  <div className="wrap-boardDetail-contents padding-header">
                    <div className="con detail">
                      <BoardDetailContents contents = {data} lnb = {lnb}/>
                      <BoardDetailComments comment = {data.comment}/>
                    </div>
  
                  </div>
                  <Footer />
                </div>
      }else{
        return <Redirect to = '/customer/qna'/>
      }
    }else{
      return  <div className="inner-boardDetail">
                  <HeaderBackground />
                  <div className="wrap-boardDetail-contents padding-header">
                    <div className="con detail">
                      <BoardDetailContents contents = {data} />
                    </div>
  
                  </div>
                  <Footer />
                </div>
    }
    
  }
  
  return (
    <div className="BoardDetail">

      {data 
      ? drawDetail()
      : ""}

    </div>
  );
}

export default BoardDetail;